import { render, staticRenderFns } from "./FleetAddEdit.vue?vue&type=template&id=52161c14&scoped=true"
import script from "./FleetAddEdit.vue?vue&type=script&lang=js"
export * from "./FleetAddEdit.vue?vue&type=script&lang=js"
import style0 from "./FleetAddEdit.vue?vue&type=style&index=0&id=52161c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52161c14",
  null
  
)

export default component.exports